import { useCartDefaultGetters } from '@/composables/useCartDefaultGetters'

export default {
  ...useCartDefaultGetters()
}
